import React from 'react'
import PropTypes from 'prop-types'
import WaypointAirDna from '../../shared/WaypointAirDna'

const propTypes = {
  homeId: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired,
}

const HomeownerAirDna = ({ homeId, onEnter }) => (
  <WaypointAirDna onEnter={onEnter} stateKey={homeId} />
)

HomeownerAirDna.propTypes = propTypes

export default HomeownerAirDna
